import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[var(--ct-bg)]">
    <Header />
    <main className="flex-1 pt-20">{children}</main>
    <Footer />
    <Toaster richColors position="top-right" />
  </div>
);

export default Layout;
